require('./depositsBox.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const classnames = require('classnames');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { Link, withRouter } = require('react-router-dom');
const includes = require('lodash/collection/includes');
const some = require('lodash/collection/some');
// @ commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
// @components
const DepositsBoxHeader = require('components/deposits/depositsBox/depositsBoxHeader/depositsBoxHeader');
const { DepositsRenovationFooter } = require('components/deposits/depositsRenovationFooter/depositsRenovationFooter');
const { DepositsRenovationInfoModal } = require('components/deposits/depositsRenovationInfoModal/depositsRenovationInfoModal');
const ImpositionsTable = require('components/deposits/impositionsTable/impositionsTable');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ utilities
const { getFundsByImposition } = require('utilities/currentAccountsHelper.js');
const { findFundByContractNumber, getFundDataForImposition } = require('utilities/investmentFundsHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
import { getDepositOfferData } from '../../../utilities/depositHelper';
import { getCompleteRenovationState } from '../../offers/helpers/depositOffersItemHelper';
// @ constants
const {
    DEPOSIT_THIRTEEN_MONTHS_PRODUCT_SUBTYPE_CODES
} = require('constants/contactCenter/addImposition');
import { DEPOSIT_HIRE_CONFIRMATION_PRODUCT_TYPE } from 'constants/index';
class DepositsBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openInfoModal: false
        };
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleToggleExpanded = this.handleToggleExpanded.bind(this);
        this.handleClickRedirection = this.handleClickRedirection.bind(this);
    }

    handleImpositionClickHandler(evt) {
        evt.stopPropagation();
    }

    buildFundsAmountTotal() {
        const { immDeposit, immInvestmentFunds } = this.props;
        const immImpositions = immDeposit.get('impositionList');
        const fundsAmountTotal = getFundsByImposition(immImpositions);
        let dataToRender = null;

        if (fundsAmountTotal.amount) {
            const fundContractNumber = immDeposit
                .getIn(['impositionList', 'byId'])
                .first()
                .get('fundContract');
            const investmentFund = findFundByContractNumber(immInvestmentFunds, fundContractNumber);
            const currentFundValue = getFundDataForImposition(investmentFund).amountObject;
            const plainAmountObject = getPlainAmountObject(currentFundValue);

            dataToRender = (
                <OKTableRow className="deposits-box__funds-amount">
                    <OKTableCell colSpan={7}>
                        <FormattedText value="depositsBox-importInDepth" />
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            className="deposits-box__funds-amount--value"
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                        />
                    </OKTableCell>
                </OKTableRow>
            );
        }

        return dataToRender;
    }

    handleClickRedirection(evt) {
        const { history, immDeposit } = this.props;
        const depositId = immDeposit.get('id');
        const impId = immDeposit.getIn(['impositionList', 'byOrder', 0]);
        const url = `/myprofile/deposits/${depositId}/imposition/${impId}`;
        const childrenClasses = [
            'ok-collapsing-toggler'
        ];

        if (!some(evt.target.parentElement.classList, (el) => includes(childrenClasses, el))) {
            history.push(url);
        }
    }

    handleToggleExpanded(isExpanded) {
        const { depositIndex } = this.props;
        this.props.onClick(isExpanded, depositIndex);
    }

    isThirteenMonthsValid() {
        const { immDeposit, immGlobalPositionSaving } = this.props;
        const endDate = immDeposit.getIn(['borderDates', 'endDate']);
        const closed = immDeposit.get('isClosed');
        const isInactiveDeposit = new Date(endDate) < new Date() || closed;
        const product = immDeposit.getIn(['contract', 'product']);
        const subProductId = immGlobalPositionSaving.get('subTypeProduct');
        const subProdIdValidatition = includes(DEPOSIT_THIRTEEN_MONTHS_PRODUCT_SUBTYPE_CODES, subProductId);
        return (!isInactiveDeposit && product === DEPOSIT_HIRE_CONFIRMATION_PRODUCT_TYPE && subProdIdValidatition);
    }

    handleOpenInfo = () => {
        this.setState({ openInfoModal: true })
    }

    closeFunction = () => {
        this.setState({ openInfoModal: false })
    }

    renovationCancel = ({ contractNumber, accountContract }) => {
        const { history, immDeposit } = this.props;
        const depositId = immDeposit.get('id');
        const url = `/myprofile/deposits/renovation/${depositId}/${contractNumber}/${accountContract}/cancel`;
        history.push(url)
    }


    buildImpositionLink() {
        const { immDeposit, hideNewDeposit } = this.props;

        if (!__CONTACT_CENTER__ || hideNewDeposit) {
            return null
        }

        const depositId = immDeposit.get('id');
        const url = `/myprofile/deposits/${depositId}/add-imposition`;
        const isValidDepositState = this.isThirteenMonthsValid();

        if (immDeposit.get('isFetching')) {
            return null;
        }

        if (isValidDepositState && immDeposit.getIn(['impositionAssociatedAccount', 'contractNumber']).length > 0) {
            return (
                <div className="deposits-box__impositions-link">
                    <Link to={url} onClick={this.handleImpositionClickHandler} modifier="inline">
                        <i className="icon icon-add-red"></i>
                        <FormattedText value="imposition-impositionLink" />
                    </Link>
                </div>
            )
        }
        else {
            return null;
        }
    }

    goToDepositsCallback = (depositIdentify, depositId, amount) => {
        const { setRenewalDepositId, setRenewalOrTransferToken, setMaxImportAmount } = this.props;
        setRenewalOrTransferToken(depositIdentify);
        setRenewalDepositId(depositId)
        setMaxImportAmount(amount)
    }

    buildDetailsLink() {
        if (!__CONTACT_CENTER__) return null;

        const { immDeposit } = this.props;
        const depositId = immDeposit.get('id');
        const url = `/myprofile/deposits/${depositId}/details`;
        const isPending = !immDeposit.getIn(['borderDates', 'startDate']);

        return (
            isPending ? null :
            <Link to={url} onClick={this.handleImpositionClickHandler} className="ok-link deposits-box__details-link">
                <FormattedText value="depositsBox-detailsLink" />
            </Link>

        );
    }

    renderFooter = (renovationState) => {
        const { immDeposit, isFetched, originCountry, offersData, immProfile, history, onHideOfferPost, hideOfferPostState, resetHideDepositOfferPost } = this.props;
        const depositOfferData = getDepositOfferData(immDeposit.getIn(['contract', 'contractNumber']), offersData);
        const { haveRenovated = false, haveRenewable = false } = renovationState;
        const taggingData = {
            type: immDeposit.get('depositType'),
            subType: immDeposit.get('depositSubType'),
            standard: immDeposit.get('depositStandard')
        };

        if (!isFetched || (!haveRenovated && !haveRenewable) || !offersData) { return null }
        return (
            <DepositsRenovationFooter
                renovationState={renovationState}
                onOpenInfo={this.handleOpenInfo}
                history={history}
                goToDepositsCallback={this.goToDepositsCallback}
                offerData={depositOfferData}
                immDeposit={immDeposit}
                immProfile={immProfile}
                immFlagBasedFeatures={this.props.immFlagBasedFeatures}
                taggingData={taggingData}
                originCountry={originCountry}
                onHideOfferPost={onHideOfferPost}
                hideOfferPostState={hideOfferPostState}
                resetHideDepositOfferPost={resetHideDepositOfferPost}
            />
        )
    }

    hasFooter = (renovationState) => {
        if (renovationState) {
            const { haveRenewable, haveRenovated } = renovationState;
            return haveRenewable || haveRenovated;
        } else {
            return false;
        }
    }

    render() {
        const { immDeposit, index, actualDate, isClosed, expanded, originCountry, offersData } = this.props;
        const immImpositionList = immDeposit.get('impositionList');
        const pendingDeposit = formatText('depositsBox-emptyImpositionPendingDeposit');
        const callOptions = <FormattedText value="depositsBox-emptyImpositionCallOptions" />;

        let fundsAmountTotal;
        let impositionTable = (
            <EmptyState primaryText={pendingDeposit} secondaryText={callOptions} iconType="noitems-banking" />
        );
        let isClickable = false;
        let haveRenewable = false;
        let renovationState = null;
        if (immImpositionList && immImpositionList.get('byId').size) {
            fundsAmountTotal = this.buildFundsAmountTotal();
            impositionTable = <ImpositionsTable isClosed={isClosed} immDeposit={immDeposit} actualDate={actualDate} originCountry={originCountry} />;

            const immImpositionListByOrder = immImpositionList.get('byOrder')
            renovationState = getCompleteRenovationState(immImpositionListByOrder, offersData, immDeposit);
            haveRenewable = renovationState.haveRenewable;
            isClickable = expanded && immImpositionListByOrder.size === 1;
        }
        const depositBoxClasses = classnames('deposits-box', {
            'deposits-box--is-expanded': expanded || haveRenewable,
            'deposits-box--is-clickable': isClickable
        });

        let clickHandler;
        if (isClickable) {
            clickHandler = this.handleClickRedirection;
        }
        return (
            <div className="deposits-box-container ">
                <div className={depositBoxClasses} onClick={clickHandler}>
                    <Accordion customClassName="deposits-box-container__accordion" isExpanded={expanded || haveRenewable} onClick={this.handleToggleExpanded}>
                        <AccordionHeader iconStyle name="AccordionHeader">
                            <DepositsBoxHeader isExpanded={expanded} immDeposit={immDeposit} index={index} />
                        </AccordionHeader>
                        <AccordionBody name="AccordionBody">
                            <div className="deposits-box__impositions">
                                {impositionTable}
                            </div>
                            <ContactCenterRender>
                                {this.buildImpositionLink()}
                                {this.buildDetailsLink()}
                            </ContactCenterRender>
                        </AccordionBody>
                    </Accordion>
                    <OKTable>
                        <tbody>
                            {fundsAmountTotal}
                        </tbody>
                    </OKTable>
                </div>
                {this.hasFooter(renovationState) && this.renderFooter(renovationState)}
                <DepositsRenovationInfoModal 
                    isOpen={this.state.openInfoModal}
                    closeFunction={this.closeFunction}
                    immDeposit={immDeposit}
                    renovationCancel={__CONTACT_CENTER__ && this.renovationCancel}
                />
            </div>
        );
    }
}

DepositsBox.propTypes = {
    actualDate: PropTypes.string.isRequired,
    hideNewDeposit: PropTypes.bool,
    index: PropTypes.string.isRequired,
    expanded: PropTypes.bool.isRequired,
    hideOfferPostState: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immDeposit: PropTypes.object.isRequired,
    immGlobalPositionSaving: PropTypes.object,
    immInvestmentFunds: PropTypes.object.isRequired,
    isClosed: PropTypes.bool,
    depositIndex: PropTypes.number,
    offersData: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    onHideOfferPost: PropTypes.func,
    originCountry: PropTypes.string.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    setRenewalOrTransferToken: PropTypes.func.isRequired,
    setRenewalDepositId: PropTypes.func.isRequired,
    setMaxImportAmount: PropTypes.func.isRequired,
    isFetched: PropTypes.bool.isRequired
};

module.exports.DepositsBox = withRouter(DepositsBox);
